import {BaseBrandedView, BaseBrandedViewOptions} from "./_BaseViews";
import * as _ from "lodash";
import * as $ from "jquery";
import {TimezoneCollection} from "../collections/Timezones";
import Auth from "@aws-amplify/auth";
import {FederatedSignInOptions} from "@aws-amplify/auth/src/types/Auth";
import {checkPasswordPolicy, PasswordPolicyItem} from "../common/passwords";

interface SetPasswordViewOptions extends BaseBrandedViewOptions {
    userId: number;
    token: string;
}

export class SetPasswordView extends BaseBrandedView {
    options: SetPasswordViewOptions;

    private template = _.template(require('templates/setPassword.html'));
    private collectionLoaded = false;
    private processComplete = false;
    private user: any = null;
    private ssoProps: any = null;

    constructor(options: SetPasswordViewOptions) {
        super(<any> _.extend(options, {
            tagName: 'div',
            events: {
                'submit .set-password-form': 'handleSubmitButtonClick',
                'click .login-federated-button': 'handleSubmitButtonClick',
                'input .set-password-form-password': 'handlePasswordInput',
                'input .set-password-form-password-2': 'handlePasswordInput',
            }
        }));

        $.when(this.getUser()).then(() => {
            return this.getSSOProps(this.user.user_email);
        }).then(() => {
            this.collectionLoaded = true;
            this.render();
        });
    };

    private getSSOProps(email) {
        return $.ajax({
            type: "GET",
            url: window.location.origin + '/sso_props?q=' + encodeURIComponent(email),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            success: (response) => {
                this.ssoProps = response
            }
        });
    }

    private getUser() {
        return $.ajax({
            type: "GET",
            url: window.location.origin + '/join/setPassword/' + this.options.userId + '/' + this.options.token,
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            success: (response) => {
                this.user = response;
            },
            error: (jqXHR) => {
                // Check if the user has already set a password
                if (jqXHR.status === 400 && jqXHR.responseJSON.code === 'EXPIRED') {
                    // Go to login page
                    location.hash = '';
                }
            }
        });
    }

    render() {
        this.$el.html(this.template({
            collectionLoaded: this.collectionLoaded,
            processComplete: this.processComplete,
            user: this.user,
            timezones: new TimezoneCollection(),
            brand: this.options.brandCollection.getBrand(),
            ssoProps: this.ssoProps,
            PasswordPolicyItem: PasswordPolicyItem
        }));

        if (this.ssoProps && this.ssoProps.sso_idp) {
            this.setSSOProvider(this.ssoProps.sso_idp_type);
        }

        return this;
    }

    private setSSOProvider(provider) {
        this.$('.federated-form-group').addClass(provider);
        this.$('.federated-form-group img').attr('src', require(`../../img/sso/${provider}.png`));
        this.$('.federated-form-group .provider-name').text(provider === 'Corporate' ? 'Corporate Account' : provider);
    }

    private handlePasswordInput() {
        var password = this.$('.set-password-form-password').val().toString();
        var policyCheck = checkPasswordPolicy(password);
        _.each(policyCheck.pass, (p) => {
            this.$(`.password-policy-item[data-item="${p}"]`).removeClass('fa-times text-danger-bright');
            this.$(`.password-policy-item[data-item="${p}"]`).addClass('fa-check text-success-bright');
        });
        _.each(policyCheck.fail, (p) => {
            this.$(`.password-policy-item[data-item="${p}"]`).addClass('fa-times text-danger-bright');
            this.$(`.password-policy-item[data-item="${p}"]`).removeClass('fa-check text-success-bright');
        });

        var passwordConfirm = this.$('.set-password-form-password-2').val().toString();
        this.$(`.password-policy-match-info`).removeClass('hidden');
        this.$(`.password-policy-match`).toggleClass('fa-times text-danger-bright', password != passwordConfirm);
        this.$(`.password-policy-match`).toggleClass('fa-check text-success-bright', password == passwordConfirm);
    }

    private handleSubmitButtonClick(e) {
        e.preventDefault();
        var errorsSelector = this.$('.set-password-form-errors');
        errorsSelector.addClass('hidden');
        var errors = [];

        var name = (<string> this.$('.set-password-form-name').val()).trim();
        if (name.length === 0) errors.push('Name may not be empty');

        var timezone = (<string> this.$('.set-password-form-timezone').val()).trim();
        var company = (<string> this.$('.set-password-form-company').val()).trim();
        var role = (<string> this.$('.set-password-form-role').val()).trim();

        var phone = (<string> this.$('.set-password-form-phone').val()).trim();
        var phoneValidator = /^[().+\d -]{7,15}$/;
        if (phone && !phone.match(phoneValidator)) errors.push('Phone Number is not valid (must include area code)');

        if (!this.ssoProps.is_sso_user) {
            var password = (<string>this.$('.set-password-form-password').val());
            var password2 = (<string>this.$('.set-password-form-password-2').val());

            if (password.length === 0) errors.push('Password may not be empty');
            if (password !== password2) errors.push('Passwords do not match');
            if (checkPasswordPolicy(password).fail.length) errors.push('Invalid password');
        }

        if(errors.length){
            errorsSelector.find('ul').html(_.map(errors, (e) => {
                return '<li>' + e + '</li>'
            }).join(''));
            errorsSelector.removeClass('hidden');
            return
        }

        if(!phone) phone = null;
        if(!company) company = null;
        if(!role) role = null;

        this.collectionLoaded = false;
        this.render();

        var data = {
            name: name,
            company_name: company,
            company_role: role,
            phone_number: phone,
            timezone: timezone
        };
        if (!this.ssoProps.is_sso_user) {
            data['password'] = password;
        }

        $.ajax({
            type: "POST",
            url: window.location.origin + '/join/setPassword/' + this.options.userId + '/' + this.options.token,
            data: JSON.stringify(data),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            success: () => {
                if (this.ssoProps.is_sso_user) {
                    return Auth.federatedSignIn(<FederatedSignInOptions>{provider: this.ssoProps.sso_idp});
                }
                this.processComplete = true;
                this.collectionLoaded = true;
                this.render();
            }
        });
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/SetPasswordView.ts